export const DEFAULT_YEAR = 2023;
export const DEFAULT_MIN_MONTH = 0;
export const DEFAULT_MAX_MONTH = 11;

export const SITEMAP_AVAILABLE_TIMES = [
  "",
  "today",
  "yesterday",
  "this-week",
  "last-week",
  "nfl-matchups",
  "nfl-scores",
];

export const SITEMAP_MENU_OPTIONS = [
  "All Years",
  "Today",
  "Yesterday",
  "This Week",
  "Last Week",
  "NFL Matchups",
  "NFL Scores & Schedule",
];

export const SITEMAP_MOBILE_MENU_OPTIONS = [
  { label: "All Years", slug: "/sitemap", value: "" },
  { label: "Today", slug: "/sitemap/today", value: "today" },
  {
    label: "Yesterday",
    slug: "/sitemap/yesterday",
    value: "yesterday",
  },
  {
    label: "This Week",
    slug: "/sitemap/this-week",
    value: "this-week",
  },
  {
    label: "Last Week",
    slug: "/sitemap/last-week",
    value: "last-week",
  },
  {
    label: "NFL Matchups",
    slug: "/sitemap/nfl-matchups",
    value: "nfl-matchups",
  },
  {
    label: "NFL Scores & Schedule",
    slug: "/sitemap/nfl-scores",
    value: "nfl-scores",
  },
];
